export interface Link {
  id?: string;
  url: string;
  title?: string;
  subtitle?: string | null;
  actions: Action[];
  widgets: Record<string, Widget>;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface Action {
  type?: SocialMedias;
  command?: CommandsEnum | string;
  value?: string;
}

export type Widget = Record<string, any>

export enum SocialMedias {
  YOUTUBE = "YOUTUBE",
  TWITTER = "TWITTER",
  INSTAGRAM = "INSTAGRAM",
  FACEBOOK = "FACEBOOK",
  TIKTOK = "TIKTOK",
  ONLYFANS = "ONLYFANS",
  SOUNDCLOUD = "SOUNDCLOUD",
  SPOTIFY = "SPOTIFY",
  TWITCH = "TWITCH",
  DISCORD = "DISCORD",
  TELEGRAM = "TELEGRAM",
  BEHANCE = "BEHANCE",
  LINKEDIN = "LINKEDIN",
  PINTEREST = "PINTEREST",
  OTHER = "OTHER"
}

export enum CommandsEnum {
  YOUTUBE_SUBSCRIBE = "YOUTUBE_SUBSCRIBE",
  YOUTUBE_LIKE_VIDEO = "YOUTUBE_LIKE_VIDEO",
  YOUTUBE_POST_CMT = "YOUTUBE_POST_CMT",

  TWITTER_FLW_USER = "TWITTER_FLW_USER",
  TWITTER_LIKE_TWT = "TWITTER_LIKE_TWT",
  TWITTER_RPLY_TWT = "TWITTER_RPLY_TWT",
  TWITTER_RETWEET =  "TWITTER_RETWEET",

  INSTAGRAM_FLW_USER = "INSTAGRAM_FLW_USER",
  INSTAGRAM_LIKE_PST = "INSTAGRAM_LIKE_PST",
  INSTAGRAM_POST_CMT = "INSTAGRAM_POST_CMT",

  FACEBOOK_LIKE_PAGE = "FACEBOOK_LIKE_PAGE",
  FACEBOOK_LIKE_POST = "FACEBOOK_LIKE_POST",
  FACEBOOK_POST_COMMENT = "FACEBOOK_POST_COMMENT",
  FACEBOOK_SHARE_POST = "FACEBOOK_SHARE_POST",

  TIKTOK_FLW_USER = "TIKTOK_FLW_USER",
  TIKTOK_LIKE = "TIKTOK_LIKE",
  TIKTOK_POST_CMT = "TIKTOK_POST_CMT",

  ONLYFANS_FOLLOW_USER = "ONLYFANS_FOLLOW_USER",

  SOUNDCLOUD_FOLLOW_USER = "SOUNDCLOUD_FOLLOW_USER",
  SOUNDCLOUD_LIKE_TRACK = "SOUNDCLOUD_LIKE_TRACK",
  SOUNDCLOUD_REPOST_TRACK = "SOUNDCLOUD_REPOST_TRACK",

  SPOTIFY_FOLLOW_ARTIST = "SPOTIFY_FOLLOW_ARTIST",
  SPOTIFY_LIKE_SONG_OR_ALBUM = "SPOTIFY_LIKE_SONG_OR_ALBUM",

  TWITCH_FOLLOW = "TWITCH_FOLLOW",

  DISCORD_JOIN_SERVER = "DISCORD_JOIN_SERVER",

  TELEGRAM_JOIN_CHANNEL = "TELEGRAM_JOIN_CHANNEL",

  BEHANCE_FOLLOW = "BEHANCE_FOLLOW",

  LINKEDIN_CONNECT = "LINKEDIN_CONNECT",
  LINKEDIN_COMPANY_FOLLOW = "LINKEDIN_COMPANY_FOLLOW",

  PINTEREST_FOLLOW = "PINTEREST_FOLLOW",
  PINTEREST_SAVE = "PINTEREST_SAVE",

  OTHER_VISIT_PAGE = "OTHER_VISIT_PAGE"
}